import { ButtonText } from '@/components/common/Button'
import { FloatingTooltip } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { GALLERY_LOCK_LABELS, type GalleryLockSlugType } from '@/defs/gallery'
import { galleryActions } from '@/store/gallery'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { cn } from '@/utils/commonUtil'

import { useGalleryDisplay } from '../../GalleryDisplayProvider/GalleryDisplayProvider'

import styles from './GalleryControlsLock.module.scss'

type Props = {
  slug: GalleryLockSlugType
}

export const GalleryControlsLock = ({ slug }: Props) => {
  const { cardFiltersCount, groupby, groupbyDefault, sortby, sortbyDefault } = useGalleryDisplay()
  const dispatch = useReduxDispatch()
  const isLocked = useReduxSelector((s) => !!s.gallery.lockedPrefSlugs?.[slug])
  const { label } = GALLERY_LOCK_LABELS[slug]

  const onClick = () => {
    dispatch(galleryActions.setLockedPrefSlug({ isLocked: !isLocked, slug }))
  }

  const isDefault =
    slug === 'groupby'
      ? groupbyDefault === groupby
      : slug === 'sortby'
        ? sortbyDefault === sortby
        : cardFiltersCount === 0

  const tooltipElement = isLocked ? (
    <p>
      <strong>Unlock {label}:</strong> Will reset when you leave this page.
    </p>
  ) : (
    <p>
      <strong>Lock {label}:</strong> Will maintain your choice on every page and between visits.
    </p>
  )

  return (
    <span className={cn(styles.container, { isDefault, isLocked, styles })}>
      <FloatingTooltip content={tooltipElement} placement='bottom'>
        <ButtonText aria-label={`Lock ${label}`} aria-pressed={isLocked} onClick={onClick}>
          <span className={styles.button}>
            <Icon name={isLocked ? 'lock' : 'lockOpen'} />
          </span>
        </ButtonText>
      </FloatingTooltip>
    </span>
  )
}
